import React from "react";
import WhiteNavBar from "./components/WhiteNavBar";
import styles from "./Pages.module.css";
import OptionsMenu from "./components/OptionsMenu";
import Footer from "./components/Footer";
import Tracker from "./components/Tracker";

export default function ProgressTracker() {
  const profile_pic = localStorage.getItem("profile_pic");
  const teacher_id = localStorage.getItem("teacher_id");

  return (
    <div className={styles.container}>
      <header>
        <WhiteNavBar />
      </header>
      <main className={styles.main}>
        <div className={styles.optionsMenu}>
          <OptionsMenu profile_pic={profile_pic} teacher_id={teacher_id} />
        </div>
        <div className={styles.tracker}>
          <Tracker teacher_id={teacher_id} />
        </div>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}
